<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you ever had ANY of the following procedures to fix a blocked heart artery?<br /><i>(Check all that apply)</i>
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.procedures">
      <b-form-checkbox v-model="survey.arteryBlockages.blockedHeartArteryProcedures.hadNoSurgery"
                       @change="onNoProcedureSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedHeartArteryProcedures.hadBalloonOpening"
                       @change="onBalloonOpeningSelected">
        Balloon opening of a blocked heart artery
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedHeartArteryProcedures.hadStent"
                       @change="onStentSelected">
        Stent of a blocked heart artery
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedHeartArteryProcedures.hadBypassSurgery"
                       @change="onBypassSurgerySelected">
        Bypass surgery of a blocked heart artery
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      procedures: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoSurgery || value.hadBalloonOpening
          || value.hadStent || value.hadBypassSurgery)
      }
    },

    computed: {
      ...mapState(["survey"]),

      procedures() { return this.survey.arteryBlockages.blockedHeartArteryProcedures; }
    },

    methods: {
      onNoProcedureSelected(value) {
        this.setOptions(value, false, false, false);
      },

      onBalloonOpeningSelected(value) {
        this.setOptions(false, value, this.procedures.hadStent, this.procedures.hadBypassSurgery);
      },

      onStentSelected(value) {
        this.setOptions(false, this.procedures.hadBalloonOpening, value, this.procedures.hadBypassSurgery);
      },

      onBypassSurgerySelected(value) {
        this.setOptions(false, this.procedures.hadBalloonOpening, this.procedures.hadStent, value);
      },

      setOptions(hadNoSurgery, hadBalloonOpening, hadStent, hadBypassSurgery) {
        this.survey.arteryBlockages.blockedHeartArteryProcedures.hadNoSurgery = hadNoSurgery;
        this.survey.arteryBlockages.blockedHeartArteryProcedures.hadBalloonOpening = hadBalloonOpening;
        this.survey.arteryBlockages.blockedHeartArteryProcedures.hadStent = hadStent;
        this.survey.arteryBlockages.blockedHeartArteryProcedures.hadBypassSurgery = hadBypassSurgery;
      }
    }
  };
</script>